<template>
  <div class="main">
    <div style="display: flex;justify-content: space-between;align-items: center;">
      <div class="crumbs">
        运营管理 > <span class="goTo" @click="goTo">点位运营数据</span> > 点位详情
      </div>
      <div style="padding-right: 5px;">
        <a-button type="primary" style="height:26px" @click="goTo">
          返回
        </a-button>
      </div>
    </div>

    <div class="content detai_center">
      <div class="header_card">
        <div v-if="productInfo.image" class="card_img">
          <!-- style="width:100%;height:100%；border-radius: 8px;" -->
          <img
            class="card_imgss"

            :src="productInfo.image"
          >
        </div>
        <div v-else class="card_img">
          <!-- style="width:100%;height:100%；border-radius: 8px;" -->
          <img
            class="card_imgss"
            src="../../../assets/image/默认图片.png" alt="默认图片"
            srcset=""
          >
        </div>

        <div class="card_info">
          <div class="card_info_top">
            <div style="display: flex; align-items: center">
              <div style="font-size: 30px">
                {{ productInfo.name }}
              </div>
              <div v-if="Number(productInfo.device) >= 60" class="info_top_btn">
                合格
              </div>
              <div v-else class="info_top_btn">
                不合格
              </div>
            </div>

            <div class="info_top_bom">
              <span style="padding-right:5px">{{ productInfo.provinceName }}</span>|<span style="padding:0 5px">{{ productInfo.cityName }}</span>|<span style="padding-left:5px">{{ productInfo.areaName }}</span>
            </div>
          </div>
          <div class="card_info_cen">
            <div style="padding-top: 16px">
              <span class="info_cen_span">点位位置</span><span class="info_cen_sp">{{ productInfo.address }}</span>
            </div>
            <div style="padding-top: 16px">
              <span class="info_cen_span">运营分数</span><span class="info_cen_sp">{{ productInfo.device }}分</span>
            </div>
            <div style="padding-top: 16px">
              <span class="info_cen_span">运营排名</span><span class="info_cen_sp">第{{ productInfo.ranking }}名</span>
            </div>
            <div style="padding: 16px 0">
              <span class="info_cen_span"> 督导人员</span><span class="info_cen_sp">{{ productInfo.supervisor }}</span>
            </div>
          </div>
          <div class="card_info_bom">
            <div class="info_bom_title">
              运营人员
            </div>
            <div v-if="productInfo.cusInfo" class="info_bom_cen">
              <div class="info_bom_img">
                <img :src="productInfo.cusInfo.headPath" style="border-radius: 50%;width:100%;height:100%">
              </div>
              <div
                class=""
                style="
                  display: flex;
                  flex-flow: column;
                  justify-content: space-between;
                "
              >
                <div style="font-weight: 500; color: #333333; font-size: 16px">
                  {{ productInfo.cusInfo.userName }}
                </div>
                <div>
                  <span class="info_cen_span">绩效评分</span>
                  <span class="info_cen_sp"> {{ productInfo.cusInfo.level }}分</span>
                </div>
              </div>
              <div
                class="bom_bom"
                style="margin-left: 53px; margin-right: 10px; color: #666666"
              >
                管辖其他点位
              </div>
              <div style="    width: 500px;    overflow: auto;    display: -webkit-box;" class="bom_bom">
                <div
                  v-for="(otherpoints,index) in productInfo.otherPoint" :key="index" class=""
                  style="color: #333333;padding-left:15px;font-weight: 500;"
                >
                  {{ index+1 }} {{ otherpoints }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="copyinfo">
        <div>
          <!-- <div v-if="JSON.stringify(gatherDate) !== '{}'" class="part1"> -->
          <div class="part1">
            <div style="font-size:22px">
              传感器采集数据
              <a-divider orientation="left">
              </a-divider>
            </div>
            <div class="part1_item">
              <a-col :span="5">
                <div class="listItem">
                  <img
                    src="https://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210426/16194219981014439dddbe6d3433cad1c283d1600f953.png"
                    alt="iconSrc"
                  >
                  <div class="right">
                    <div class="title">
                      温度
                    </div>
                    <div class="content">
                      当前温度
                      <span class="ml15">{{ gatherDate.temperature || 0 }}℃</span>
                    </div>
                    <div class="desc">
                      舒适度 <span class="ml15">适宜</span>
                    </div>
                  </div>
                </div>
              </a-col>
              <a-col :span="5">
                <div class="listItem">
                  <img
                    src="https://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210426/16194220142018019b024e3b5493eba18de126f0a2807.png"
                    alt="iconSrc"
                  >
                  <div class="right">
                    <div class="title">
                      湿度
                    </div>
                    <div class="content">
                      体感湿度
                      <span class="ml15">{{ gatherDate.humidity || 0 }}%</span>
                    </div>
                    <div class="desc">
                      舒适度 <span class="ml15">良好</span>
                    </div>
                  </div>
                </div>
              </a-col>
              <a-col :span="5">
                <div class="listItem">
                  <!-- <img
                    src="https://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210426/16194220323203294109ca6ed4689bacac67fb1ed4a18.png"
                    alt="iconSrc"
                  > -->
                  <img src="http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20211009/16337620370650b2d963c293f444ea7e483d7b69506df.png" style="width:48px;height:48px" alt="iconSrc">
                  <div class="right">
                    <div class="title">
                      异味
                    </div>
                    <div class="content">
                      氨气
                      <span
                        class="ml15"
                      >{{ gatherDate.ammoniaConcentration || 0 }}PPM</span>
                    </div>
                    <div class="desc">
                      硫化氢
                      <span
                        class="ml15"
                      >{{ gatherDate.hydrogenSulfideConcentration || 0 }}PPM</span>
                    </div>
                  </div>
                </div>
              </a-col>
              <a-col :span="5">
                <div class="listItem">
                  <img
                    src="https://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210426/161942206353433ef2ff5af3c472b9103a04e33b4b470.png"
                    alt="iconSrc"
                  >
                  <div class="right">
                    <div class="title">
                      光照感应
                    </div>
                    <div class="content">
                      档位
                      <span class="ml15">{{
                        gatherDate.illumination | gearsFilter
                      }}</span>
                    </div>
                    <div class="desc">
                      光强
                      <span class="ml15">{{ gatherDate.illumination || 0 }}LUX</span>
                    </div>
                  </div>
                </div>
              </a-col>
              <a-col :span="4">
                <div class="listItem">
                  <img
                    src="https://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210426/161942208212579a4c8b8d0af4f63a6a74f740e9763bd.png"
                    alt="iconSrc"
                  >
                  <div class="right">
                    <div class="title">
                      烟雾
                    </div>
                    <div class="content">
                      状态
                      <span class="ml15">
                        <span
                          v-if="gatherDate.smokeStatus === '1'" class="red"
                        >有烟雾</span>
                        <span v-else class="green">正常</span>
                      </span>
                    </div>
                  </div>
                </div>
              </a-col>
            </div>
            <!-- <div>
              <a-divider orientation="left">
                运营数据图片/视频
              </a-divider>
            </div> -->
            <!-- <div class="ml40">
              <viewer v-if="gatherDate.photo">
                <img
                  v-if="gatherDate.photo"
                  style="width: 250px"
                  :src="gatherDate.photo"
                  alt="图片"
                >
              </viewer>
              <span v-else>
                <a-empty />
              </span>
            </div> -->
          </div>
          <!-- <div v-if="JSON.stringify(gatherDate) === '{}' && !skeletonFlag">
            <a-empty />
          </div>
          <div v-if="skeletonFlag">
            <a-skeleton active />
          </div> -->
        </div>
      </div>
      <div>
        <div class="info_bom_title">
          居民满意度
          <a-divider orientation="left">
          </a-divider>
        </div>
        <!-- v-if="man" -->
        <div v-if="man" style="display: flex;justify-content: space-between;height: 154px;background: #FAFAFA;">
          <div class="man" style="width:20%">
            <div class="man_top">
              环境整洁
            </div>
            <div class="man_cen">
              满意度{{ man.tidyPraiserate || 100 }}%
            </div>
            <div style="width:236px">
              <a-progress :percent="man.tidyPraiserate || 100" :show-info="false" />
            </div>
          </div>
          <div class="man" style="width:20%">
            <div class="man_top">
              运营规范
            </div>
            <div class="man_cen">
              满意度{{ man.standardPraiserate || 100 }}%
            </div>
            <div style="width:236px">
              <a-progress :percent="man.standardPraiserate || 100" :show-info="false" />
            </div>
          </div>
          <div class="man" style="width:20%">
            <div class="man_top">
              空气清新
            </div>
            <div class="man_cen">
              满意度{{ man.qualityPraiserate || 100 }}%
            </div>
            <div style="width:236px">
              <a-progress :percent="man.qualityPraiserate || 100" :show-info="false" />
            </div>
          </div>
          <div class="man" style="width:20%">
            <div class="man_top">
              操作便捷
            </div>
            <div class="man_cen">
              满意度{{ man.convenientPraiserate || 100 }}%
            </div>
            <div style="width:236px">
              <a-progress :percent="man.convenientPraiserate || 100" :show-info="false" />
            </div>
          </div>
        </div>
        <div v-else style="display: flex;justify-content: space-between;height: 154px;background: #FAFAFA;">
          <div class="man" style="width:20%">
            <div class="man_top">
              环境整洁
            </div>
            <div class="man_cen">
              满意度 100%
            </div>
            <div style="width:236px">
              <a-progress :percent="100" :show-info="false" />
            </div>
          </div>
          <div class="man" style="width:20%">
            <div class="man_top">
              运营规范
            </div>
            <div class="man_cen">
              满意度 100%
            </div>
            <div style="width:236px">
              <a-progress :percent="100" :show-info="false" />
            </div>
          </div>
          <div class="man" style="width:20%">
            <div class="man_top">
              空气清新
            </div>
            <div class="man_cen">
              满意度 100%
            </div>
            <div style="width:236px">
              <a-progress :percent=" 100" :show-info="false" />
            </div>
          </div>
          <div class="man" style="width:20%">
            <div class="man_top">
              操作便捷
            </div>
            <div class="man_cen">
              满意度 100%
            </div>
            <div style="width:236px">
              <a-progress :percent=" 100" :show-info="false" />
            </div>
          </div>
        </div>
      <!-- <div v-else>
          <a-empty />
        </div> -->
      </div>
      <div>
        <div>
          <div class="info_bom_title">
            最新的投递监管
            <a-divider orientation="left">
            </a-divider>
          </div>
          <!-- <div style="display:flex;    justify-content: space-around;"> -->
          <div style="display:flex;justify-content: space-around;">
            <div v-if="alarmPhoto.image" style="width:417px;height:270px;position: relative;">
              <viewer :images="[alarmPhoto.image]">
                <img :src="alarmPhoto.image" :images="alarmPhoto.image" style="border-radius: 8px;">
              </viewer>

              <div v-if="alarmPhoto.alarmEvent" class="alarmPhoto_div">
              </div>
              <div class="alarmPhoto_bom">
                {{ alarmPhoto.alarmEvent }}
              </div>
            </div>
            <div v-else>
              <a-empty />
            </div>
            <div v-if="alarmPhoto.image2" style="width:417px;height:270px;position: relative;">
              <viewer :images="[alarmPhoto.image2]">
                <img :src="alarmPhoto.image2" :images="alarmPhoto.image2" style="border-radius: 8px;">
              </viewer>

              <div v-if="alarmPhoto.alarmEvent" class="alarmPhoto_div">
              </div>
              <div class="alarmPhoto_bom">
                {{ alarmPhoto.alarmEvent }}
              </div>
            </div>
            <div v-else>
              <a-empty />
            </div>
            <div style="width:417px;height:270px;position: relative;"></div>
          </div>
          <!-- <div v-else>
            <a-empty />
          </div> -->
        <!-- <div></div>
          </div> -->
        </div>

        <div>
          <div
            style="display: flex;justify-content: space-between;"
          >
            <div class="info_bom_title">
              最新的运营监管
            <!-- <a-divider orientation="left">
              </a-divider> -->
            </div>
            <div class="modalimg">
              <a-radio-group
                button-style="solid" default-value="a"
                @change="onChange"
              >
                <a-radio-button value="a">
                  外部
                </a-radio-button>
                <a-radio-button value="b">
                  内部
                </a-radio-button>
              </a-radio-group>
            </div>
          </div>
          <a-divider orientation="left" style="margin: 0 0 30px 20px;">
          </a-divider>
          <div
            v-if="imgchoice === 'a' && picture"
            style="display: flex;
               justify-content: space-around;"
          >
            <div style="width:417px;height:270px;position: relative;">
              <viewer :images="[picture.originalImg]">
                <img :src="picture.originalImg" :images="picture.originalImg" style="border-radius: 8px;">
              </viewer>

              <div class="pictureLise">
              <!-- <span>标准环境</span> -->
              </div>
              <div class="picture_bom" style="left:180px">
                标准环境
              </div>
            </div>
            <div style="width:417px;height:270px;position: relative;">
              <viewer :images="[picture.redAreaImg]">
                <img :src="picture.redAreaImg" :images="picture.redAreaImg" style="border-radius: 8px;">
              </viewer>

              <div class="pictureLise">
              <!-- <span>线框图</span> -->
              </div>
              <div class="picture_bom">
                线框图
              </div>
            </div>
            <div style="width:417px;height:270px;position: relative;">
              <viewer :images="[picture.hotImg]">
                <img :src="picture.hotImg" :images="picture.hotImg" style="border-radius: 8px;">
              </viewer>

              <div class="pictureLise">
              <!-- <span>热力图</span> -->
              </div>
              <div class="picture_bom">
                热力图
              </div>
            </div>
          </div>
          <div v-if="imgchoice === 'a' && picture == ''">
            <a-empty />
          </div>
          <div
            v-if="imgchoice === 'b' && picture"
            style="display: flex;
               justify-content: space-around;"
          >
            <div style="width:417px;height:270px;position: relative;">
              <viewer :images="[picture.originalImg]">
                <img :src="picture.originalImg" :images="picture.originalImg" style="border-radius: 8px;">
              </viewer>

              <div class="pictureLise">
              <!-- <span>标准环境</span> -->
              </div>
              <div class="picture_bom" style="left:181px">
                标准环境
              </div>
            </div>
            <div style="width:417px;height:270px;position: relative;">
              <viewer :images="[picture.redAreaImg]">
                <img :src="picture.redAreaImg" :images="picture.redAreaImg" style="border-radius: 8px;">
              </viewer>

              <div class="pictureLise">
              </div>
              <div class="picture_bom">
                线框图
              </div>
            </div>
            <div style="width:417px;height:270px;position: relative;">
              <viewer :images="[picture.hotImg]">
                <img :src="picture.hotImg" :images="picture.hotImg" style="border-radius: 8px;">
              </viewer>

              <div class="pictureLise">
              </div>
              <div class="picture_bom">
                热力图
              </div>
            </div>
          </div>
          <div v-if="imgchoice === 'b' && picture == ''">
            <a-empty />
          </div>
        </div>

        <div>
          <div class="info_bom_title">
            厨余垃圾纯净度 <span
              v-if="garbageImage.purity" style="font-weight: 500;color: #3D7FFF;"
            >{{ garbageImage.purity }}%</span>
          </div>
          <a-divider orientation="left">
          </a-divider>
          <div v-if="garbageImage.deliveryImg" style="width:417px;height:270px;display: inline-block;margin-left: 58px;">
            <viewer :images="[garbageImage.deliveryImg]">
              <img :src="garbageImage.deliveryImg" :images="garbageImage.deliveryImg" style="border-radius: 8px;">
            </viewer>
          </div>
          <div v-if="garbageImage.image" style="width:417px;height:270px;display: inline-block;margin-left:56px">
            <viewer :images="[garbageImage.image]">
              <img :src="garbageImage.image" :images="garbageImage.image" style="border-radius: 8px;">
            </viewer>
          </div>
          <div v-else>
            <a-empty />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getProductDetail, getProductDetails, getOperationPhoto, getScoreStatistics } from '@/api/operation'
import Vue from 'vue'
export default {
  filters: {
    gearsFilter (val) {
      let text = ''
      switch (true) {
        case val <= 50:
          text = '低亮'
          break
        case val > 50 && val < 70:
          text = '中亮'
          break
        case val >= 70:
          text = '高亮'
          break
        default:
          text = ''
          break
      }
      return text
    }
  },
  data () {
    return {
      queryObj: {},
      gatherDate: {},
      skeletonFlag: false,
      listBuj: {},
      imgchoice: 'a',
      picture: {
        aa: ''
      },
      productInfo: {},
      alarmPhoto: {},
      garbageImage: {},
      man: {}
    }
  },
  created () {

  },
  mounted () {
    const queryObj = JSON.parse(this.$route.query.info)
    this.queryObj = queryObj
    // console.log(this.queryObj, 'this.queryObj')
    this.getProductDetails()
    this.getOperationPhoto()
    this.getScoreStatistics()
    this.getDetail()
  },
  methods: {
    getDetail () {
      this.skeletonFlag = true
      const item = this.queryObj

      const params = {
        estateId: item.estateId,
        id: item.id
      }
      getProductDetail(params).then((res) => {
        // console.log(res.result, 'res.result')
        const result = res.result
        this.gatherDate = result || {}
        this.skeletonFlag = false
      })
    },
    getProductDetails () {
      const params = {
        id: this.queryObj.id
        // id: 1
      }
      getProductDetails(params).then((res) => {
        this.listBuj = res.result
        this.alarmPhoto = res.result.alarmPhoto
        this.garbageImage = res.result.garbageImage
        this.productInfo = res.result.productInfo
        // console.log(res, '数据')
      })
    },
    getOperationPhoto () {
      const params = {
        id: this.queryObj.id,
        type: 1
      }
      getOperationPhoto(params).then((res) => {
        this.picture = res.result.productPhoto
      })
    },
    onChange (e) {
      this.imgchoice = e.target.value

      const params = {
        id: this.queryObj.id,
        type: e.target.value === 'b' ? 2 : 1
      }

      getOperationPhoto(params).then((res) => {
        this.picture = res.result.productPhoto
        Vue.set(this.picture, res.result.productPhoto)
      })
    },
    // 居民满意度
    getScoreStatistics () {
      // productId: this.queryObj.productId
      const params = {
        productId: this.queryObj.productId
      }
      getScoreStatistics(params).then((res) => {
        this.man = res.result
      })
    },
    goTo () {
      // console.log(this.$route.query.ids, 'idssss')

      if (this.$route.query.type === 6) {
        this.$router.push({ path: '/operationsManaments/pointOperations/list', query: { zoom: 18, ids: this.queryObj.estateId }})
      } else {
        this.$router.push({ path: '/operationsManaments/pointOperations/list', query: { zoom: 17 }})
      }
      return
    }
  }
}
</script>
<style scoped>
.goTo:hover{
cursor:pointer;
color: #1890ff;
}
.detai_center {
  padding: 45px 50px 0px 45px;
}
.header_card {
  display: flex;
}
.card_img {
  width: 656px;
  height: 396px;
  margin-right: 44px;
  /* background: #1d77f9; */
}
.card_imgss {
  width: 100%;
  height: 100%;
  border-radius: 8px;
}
.card_info {
  width: calc(100% - 656px);
}
.card_info_top {
  border-bottom: solid 1px #d8d8d8;
}
.info_top_btn {
  width: 70px;
  height: 28px;
  line-height: 27px;
  text-align: center;
  color: #1d77f9;
  background: #e5f0ff;
  border-radius: 3px;
  margin-left: 32px;
  display: inline-block;
}
.info_top_bom {
  font-size: 16px;
  padding-bottom: 18px;
  margin-top: 8px;
}
.card_info_cen {
  height: 172px;
  border-top: solid 1px rgba(200, 220, 247, 0.5);
  border-bottom: solid 1px rgba(200, 220, 247, 0.5);
}
.info_cen_span {
  font-size: 16px;
  margin-right: 20px;
  color: #666666;
}
.info_cen_sp {
  font-size: 16px;
  color: #333333;
}
.info_bom_title {
  font-size: 22px;
  font-weight: 500;
  margin-top: 18px;
  margin-bottom: 16px;
  color: #333333;
}
.info_bom_cen {
  display: flex;
}
.info_bom_img {
  width: 64px;
  height: 64px;
  /* background: red; */
  border-radius: 50%;
  margin-right: 18px;
}
.bom_bom {
  display: flex;
  align-items: flex-end;
}
.man {
      margin-top: 30px;
    margin-left: 77px;
    margin-bottom: 38px;
    border-right: solid 1px #CCCCCC;
}
.man_top {
  font-size: 14px;
}
.man_cen {
  font-size: 20px;
  padding-top: 12px;
  padding-bottom: 15px;
}
.pictureLise{
    position: absolute;

    /* z-index: 999; */
    width: 80px;
height: 30px;
background: #000000;
border-radius: 3px;
opacity: 0.34;
    bottom: 46px;
    /* left: 42%; */
    left: 168px;
    font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
text-align: center;
line-height: 30px;
color: #FFFFFF;

}
.alarmPhoto_div {
     position: absolute;
    height: 30px;
    height: 30px;
    background: #000000;
    border-radius: 0px 0px 8px 8px;
    opacity: 0.35;

    width: 100%;
    bottom: 35px;
    text-align: center;
    line-height: 30px;
}
.alarmPhoto_bom {
position: absolute;
 color: #fff;
 bottom: 40px;
 left: 173px;
}
.picture_bom {
  color: #fff;
    position: absolute;
    bottom: 52px;
    left: 187px;

    z-index: 888;
}
</style>
<style lang="stylus" scoped>
.main {
  width: 100%;
  height: 100%;

  .crumbs {
    margin: 10px 0;
  }

  .content {
    width: 100%;

    background-color: #fff;

    .copyinfo {
      margin-top:20px
      .part1 {
        .part1_item {
          height: 164px;
          margin-left: 40px;
          display: flex;
          align-items: center;
        }

        .part2_item {
          height: 120px;
          margin-left: 40px;
        }

        .ml40 {
          margin-left: 40px;
        }

        .listItem {
          display: flex;
          align-items: center;
          margin: 20px;

          .right {
            margin-left: 20px;

            .title {
              font-size: 15px;
              color: #000000;
            }

            .content {
              margin-top: 5px;
              font-size: 12px;
              color: gray;

              .ml15 {
                margin-left: 10px;

                .green {
                  color: #5ab769;
                }

                .red {
                  color: #f30017;
                }
              }
            }

            .desc {
              font-size: 12px;
              color: gray;

              .ml15 {
                margin-left: 10px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
